import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-description-error-dialog',
  templateUrl: './description-error-dialog.component.html',
  styleUrls: ['./description-error-dialog.component.html'],
})
export class DescriptionErrorDialogComponent implements OnInit {
  title?: string;
  error?: string;

  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef
  ) {}

  ngOnInit(): void {
    this.title = this.config.data?.title;
    this.error = this.config.data?.error;
  }

  close(): void {
    this.error = '';
    this.ref.close();
  }
}
